var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9225 0.231048C12.7992 0.128557 12.6531 0.0572064 12.4965 0.023012C12.3399 -0.0111825 12.1773 -0.00721869 12.0225 0.0345691C11.8678 0.0763568 11.7253 0.154744 11.6072 0.263121C11.489 0.371499 11.3987 0.50669 11.3438 0.657298L8.59375 8.20855L5.57375 5.2823C5.47233 5.18393 5.35121 5.10817 5.21838 5.06001C5.08556 5.01185 4.94403 4.99238 4.80313 5.00289C4.66223 5.01341 4.52516 5.05365 4.40095 5.12099C4.27674 5.18833 4.1682 5.28122 4.0825 5.39355C1.375 8.94105 0 12.5098 0 15.9998C0 18.9172 1.15893 21.7151 3.22183 23.778C5.28473 25.8409 8.08262 26.9998 11 26.9998C13.9174 26.9998 16.7153 25.8409 18.7782 23.778C20.8411 21.7151 22 18.9172 22 15.9998C22 8.56855 15.6513 2.4998 12.9225 0.231048Z",
    fill: "url(#paint0_linear_668_1619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_1619",
    x1: -6.55651e-7,
    y1: 26.9998,
    x2: 28.3505,
    y2: 14.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesire);
export default __webpack_public_path__ + "static/media/Desire.c41cc131b3cbda611107917eec8e6c68.svg";
export { ForwardRef as ReactComponent };